import { clsx } from 'clsx';
import { classHrComponentsVersion } from 'src/HrdsSettings';

import { canUseDOM } from '../../lib/canUseDOM';
import { enablePointerFocusPolyfill } from '../../lib/polyfills/pointerFocus';
import { cnTheme } from '../Theme.cn';
import type { ConfigureRootThemeOptions, GetClassesOfHrComponentsParams } from '../Theme.types';
import { ControlSize } from '../Theme.types';
export { cnTheme } from '../Theme.cn';
export type { Theme } from '../Theme.types';

const allThemeClassNames = Array.from(
    new Set([
        ...cnTheme({ root: 'hrLight', color: 'hrLight' }).split(' '),
        ...cnTheme({ root: 'hrDark', color: 'hrDark' }).split(' '),
        ...cnTheme({ controls: 'inline' }).split(' '),
        ...cnTheme({ controls: 'size_s' }).split(' '),
        ...cnTheme({ controls: 'size_m' }).split(' '),
        ...cnTheme({ controls: 'size_l' }).split(' '),
    ]),
);

export const configureRootTheme = ({
    theme,
    controls,
    root = canUseDOM() ? document.body : null,
}: ConfigureRootThemeOptions) => {
    if (!canUseDOM()) {
        return;
    }

    if (!root) {
        throw new Error(
            'Значение в root не является DOM-элементом, невозможно установить глобальную тему.',
        );
    }

    // Удаляем все классы, связанные с темой
    root.classList.remove(...allThemeClassNames);
    // Добавляем актуальные
    root.classList.add(
        ...getClassesOfHrComponents({
            theme,
            controls,
            withHrComponentsVersion: false,
        }).split(' '),
    );

    enablePointerFocusPolyfill();
};

/**
 * Возвращает классы, необходимые HRDS для корректной работы
 */
export function getClassesOfHrComponents({
    theme,
    controls = ControlSize.medium,
    withHrComponentsVersion = true,
}: GetClassesOfHrComponentsParams): string {
    return clsx(
        withHrComponentsVersion && classHrComponentsVersion,
        cnTheme(theme).split(' '),
        controls,
        'Theme',
        'Theme_typography',
        'Theme_legacy',
    );
}
